import { rem } from "polished";
import styled from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const Container = withViewportStyle("div")`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  min-height: ${rem(700)};
  border: ${rem(40)} solid ${({ theme }) =>
  theme.colors[ColorLabels.BACKGROUND]};

  ${(props) => props.$viewport.tablet`
    padding: 0 ${rem(24)};
    border: ${rem(24)} solid ${({ theme }) =>
    theme.colors[ColorLabels.BACKGROUND]};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(80)} ${rem(16)};
    min-height: 0;
    border: 0;
  `}
`;

export const ImageWrapper = withViewportStyle("div")`
  width: 100%;
  height: 100%;
  position: absolute;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.7);
  }
`;

export const Image = styled.img<{
  $position: ImagePosition;
  imageFit?: ImageFit;
}>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-fit: ${({ imageFit }) => imageFit || "cover"};
  object-position: ${({ $position }) => $position};
  overflow: hidden;
`;

export const Content = withViewportStyle("div")`
  display: grid;
  grid-gap: ${rem(16)};
  align-content: center;
  max-width: ${rem(1016)};
  position: relative;

  .text-primitive {
    color: #ffffff;
    text-align: center;
  }

  .nolan .ck-content h1,
  .nolan .ck-content h2,
  .nolan .ck-content h3,
  .nolan .ck-content h4,
  .nolan .ck-content h5,
  .nolan .ck-content p,
  .nolan .ck-content li {
    color: #ffffff !important;
    margin: 0;
  }

  ${(props) => props.$viewport.mobile`
    grid-row-gap: ${rem(24)};

    h4 {
      margin: ${rem(14)} 0 ${rem(22)};
    }
  `}
`;

export const LogoWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = withViewportStyle("img")<{ isLogoResized: boolean }>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
  max-width: 100%;
  object-fit: contain;
  margin-bottom: ${rem(24)};

  ${(props) => props.$viewport.tablet`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(40))};
    margin-bottom: ${rem(18)};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(40))};
    margin-bottom: ${rem(8)};
  `}
`;

export const ButtonWrapper = withViewportStyle(StyledButtonContainer)`
  text-align: center;
  margin-top: ${rem(8)};

  .button-primitive {
    background: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
    color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  }
`;
